import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from "@angular/common/http";
import { BehaviorSubject, Observable, delay, throwError, of } from "rxjs";
import { QueryConstants } from "../query.constants";
import {
  CheckoutQueryRequest,
  CopyQueryRequest,
  IColumnJoin,
  IExecuteQueryRequestDTO,
  IGetJoinsForColumnRequestDTO,
  IQueryDataForDesignerResponse,
  IRecentQueriesResponse,
  IUpdateTableSettingsDTO,
  QueryDataSetResponse,
  QueryParamsResponse,
  ITenantInfoDTO,
  IQuery,
  GetPossibleColumnsResponse,
  IList,
  IListItem,
} from "../../../view-model/query-builder.view-model";
import { DataQueryBuilderService } from "./data-query-builder.service";
@Injectable({
  providedIn: "root",
})
export class ApiQueryBuilderService {
  constructor(private http: HttpClient, private dataQueryBuilderService : DataQueryBuilderService) {}

  httpOptions = {
    headers: new HttpHeaders({
      tenantid: "CaseWorthy",
      "Content-Type": "application/json",
    }),
  };

  getMostUsedTableData(body: any): Observable<any> {
    const url: string =
      QueryConstants.getTable_Url +
      `?QueryCategoryID=${body.QueryCategoryID}&SchemaName=${body.SchemaName}&ObjectName=${body.ObjectName}&ShowTablesOnly=${body.ShowTablesOnly}&CurrentUserID=${body.CurrentUserID}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  getSearchedTableData(body: any): Observable<any> {
    return this.http.post<any>(
      QueryConstants.getFilteredTable_Url,
      body,
      this.httpOptions
    );
  }

  getListData(id: number, listName:string): Observable<any> {
    const url = QueryConstants.getallLists_Url+"?listId=" + id+"&listName="+listName;
    return this.http.get<IList>(url, this.httpOptions);
  }

  getListItemData(id: number): Observable<any> {
    const url = QueryConstants.getallListItem_Url+"?listId=" + id;
    return this.http.get<IListItem>(url, this.httpOptions);
  }


  getQueryKeywordUrl(): Observable<any> {
    return this.http.get<any>(QueryConstants.keywords_Url, this.httpOptions);
  }

  getUsers(): Observable<any> {
    return this.http.get<any>(QueryConstants.getUsers_Url, this.httpOptions);
  }

  getUserImage(id: number): Observable<any> {
    return this.http.get(QueryConstants.getUsers_image_Url + id, {
      responseType: "blob",
    });
  }

  getSearchedQueryData(body: any): Observable<any> {
    return this.http.post<IQuery[]>(
      QueryConstants.getQuery_Url,
      body,
      this.httpOptions
    );
  }

  getQueryDataById(id: number): Observable<any> {
    return this.http.get<any>(QueryConstants.base_Url + id, this.httpOptions);
  }

  getCheckoutQuery(id: number): Observable<any> {
    const url = QueryConstants.get_checkout_data_url + "?queryid=" + id;
    return this.http.get<any>(url, this.httpOptions);
  }
  getDataSetForQuery(id: number): Observable<any> {
    const url = QueryConstants.get_dataset_url + "?queryid=" + id;
    return this.http.get<QueryDataSetResponse>(url, this.httpOptions);
  }

  getQueryTable(body: any): Observable<any> {
    var tableNameArray = body.schemaObjectName.split('.');
    if (this.dataQueryBuilderService.isTableExistsInQuery(tableNameArray[0], tableNameArray[1])) {
      var existingData = this.dataQueryBuilderService.getQueryTableWithColumns(tableNameArray[0], tableNameArray[1]);
      return of(existingData);
    }
    const url: string =
      QueryConstants.get_query_table_url +
      `?schemaObjectName=${body.schemaObjectName}&CurrentUserID=${body.CurrentUserID}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  checkoutQuery(body: CheckoutQueryRequest): Observable<any> {
    return this.http.post<any>(
      QueryConstants.checkout_query_data_url,
      body,
      this.httpOptions
    );
  }

  checkinQuery(body: CheckoutQueryRequest): Observable<any> {
    return this.http.post<any>(
      QueryConstants.checkin_query_data_url,
      body,
      this.httpOptions
    );
  }
  copyQuery(body: CopyQueryRequest): Observable<any> {
    return this.http
      .post<any>(QueryConstants.copy_query_data_url, body, this.httpOptions)
      .pipe(delay(2000));
  }

  updateQueryData(updateData: any): Observable<any> {
    return this.http.put<any>(
      QueryConstants.base_Url,
      JSON.stringify(updateData),
      this.httpOptions
    );
  }

  createNewQueryData(createData: any): Observable<any> {
    return this.http
      .post<any>(
        QueryConstants.base_Url,
        JSON.stringify(createData),
        this.httpOptions
      )
      .pipe(delay(2000));
  }

  deleteQuery(id: number): Observable<any> {
    return this.http.delete<any>(
      QueryConstants.base_Url + id,
      this.httpOptions
    );
  }

  getPrimaryKeyData(body: any): Observable<any> {
    const url =
      QueryConstants.get_primary_key_url +
      `?ObjectName=${body.object_name}&SchemaName=${body.schema_name}&CategoryID=${body.category_id}&CurrentUserID=${body.current_user_id}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getColumnsObjectData(body: any): Observable<any> {
    const url =
      QueryConstants.get_columns_data_object_url +
      `?ObjectName=${body.object_name}&SchemaName=${body.schema_name}&CurrentUserID=${body.current_user_id}`;
    return this.http.get<any>(url, this.httpOptions);
  }

  getQueryCategory(): Observable<any> {
    return this.http.get<any>(QueryConstants.category_Url, this.httpOptions);
  }

  updateTableSettings(
    updateTableSettingsData: IUpdateTableSettingsDTO
  ): Observable<IUpdateTableSettingsDTO> {
    return this.http.put<IUpdateTableSettingsDTO>(
      `${QueryConstants.update_query_table_url}`,
      updateTableSettingsData,
      this.httpOptions
    );
  }

  getTableSettings(queryTableId: number): Observable<IUpdateTableSettingsDTO> {
    return this.http.get<IUpdateTableSettingsDTO>(
      `${QueryConstants.get_query_table_url}/${queryTableId}`,
      this.httpOptions
    );
  }

  getRecentQueries(body: any) {

    return this.http.post<IRecentQueriesResponse[]>(
      QueryConstants.get_recent_queries_url,
      body,
      this.httpOptions
    );
  }

  disableEnableQuery(body: any): Observable<any> {
    return this.http.post<any>(
      body.disable
        ? QueryConstants.disable_query_url
        : QueryConstants.enable_query_url,
      body,
      this.httpOptions
    );
  }
  getQueryParams(queryId: number) {
    const url = QueryConstants.get_query_params_url + "?queryId=" + queryId;
    return this.http.get<QueryParamsResponse[]>(`${url}`, this.httpOptions);
  }

  getQueryLoadForDesigner(
    queryId: number
  ): Observable<IQueryDataForDesignerResponse> {
    const url = `${QueryConstants.get_queryloadfordesigner_url}?queryId=${queryId}`;
    return this.http.get<IQueryDataForDesignerResponse>(
      `${url}`,
      this.httpOptions
    );
  }

saveQuery():Observable<any> {
  let data = this.dataQueryBuilderService.getCurrentVersionOfQuery();
  data.query.queryTables = [];
    const url =
    `${QueryConstants.save_query}`;
  return this.http.post<any>(`${url}`,  JSON.stringify(data), this.httpOptions);
}

executeQuery(body: IExecuteQueryRequestDTO): Observable<any> {
  return this.http.post<any>(
    QueryConstants.execute_query_data_url,
    body,
    this.httpOptions
  );
}

exportQuery(id: number): Observable<any> {
  const url = QueryConstants.export_Query + "?queryid=" + id;
  return this.http.get(url, {
    responseType: 'blob',
    observe: 'response'
  });
}

getColumnJoins(request:IGetJoinsForColumnRequestDTO)
{
  return this.http.post<IColumnJoin[]>(QueryConstants.get_joinsForColumns_url, request, this.httpOptions);
}

getTenantInfo(): Observable<ITenantInfoDTO> {
  const url = QueryConstants.getTenantInfo_Url;
  return this.http.get<ITenantInfoDTO>(`${url}`, this.httpOptions);
}

  getPossibleColumnsByQueryId(queryId: number): Observable<GetPossibleColumnsResponse[]> {
    const url = QueryConstants.getpossibleColumns_Url + "?queryid=" + queryId;
    return this.http.get<GetPossibleColumnsResponse[]>(`${url}`, this.httpOptions);
  }

handleError(error: any) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(() => {
      return errorMessage;
    });
  }

  getErrorMessageFromResponse(error: HttpErrorResponse) : string {
    let message = `${error.statusText}- ${error.error.title}`;
    if (error?.error?.errors) {
      message += ':' + Object.values(error.error.errors).join(',');
    }
    return message;
  }
}
